module.exports = __webpack_public_path__ + "static/media/hyperthermia_warning.fc6dbdd3.svg";